import { useLocStrings } from '@office-start/loc-service';
import ToastContainerControl, { ToastElementControl, } from '@office-start/toast-container-control';
import { ToastTypes } from '@office-start/toast-types';
import { useToast, useToastActionCreators } from '@office-start/toast-utility';
import React, { useCallback } from 'react';
import { useInstrumentActionClick } from './hooks/useInstrumentActionClick';
/**
 * A Toast container component 🍞
 * @returns A toast container that renders the currently set toast within a toast container control
 */
export var ToastContainerComponent = function () {
    var toast = useToast();
    var toastActioncreators = useToastActionCreators();
    var locStrings = useLocStrings().data;
    useInstrumentActionClick(toast);
    var dismissToastCallback = useCallback(function () {
        toastActioncreators.clearNotification();
    }, [toastActioncreators]);
    if (!toast || !locStrings) {
        return null;
    }
    var toastType = toast.type, message = toast.message, actionInfo = toast.actionInfo, linkInfo = toast.linkInfo;
    return (React.createElement(ToastContainerControl, { ariaBusy: toastType === ToastTypes.InProgress, ariaLabel: "".concat(locStrings.documentActionsToastResources.toastNotificationText, " ").concat(message || ''), ariaLive: toastType === ToastTypes.Error ? 'assertive' : 'polite', callToAction: actionInfo === null || actionInfo === void 0 ? void 0 : actionInfo.onClick, onDismiss: dismissToastCallback, 
        // Auto dismiss all toasts except errors that have an onClick
        autoDismiss: toastType === ToastTypes.Success ||
            (toastType === ToastTypes.Error && !(actionInfo === null || actionInfo === void 0 ? void 0 : actionInfo.onClick)) },
        React.createElement(ToastElementControl, { ariaLabel: locStrings.documentActionsToastResources
                .toastMessageAriaLabel, buttonAriaLabel: locStrings.documentActionsToastResources
                .toastButtonAriaLabel, type: toastType, label: message, link: linkInfo
                ? {
                    url: linkInfo.url,
                    label: linkInfo.label,
                }
                : undefined, button: actionInfo })));
};
//# sourceMappingURL=ToastContainerComponent.js.map